"use client";
import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function Home() {
  const router = useRouter();
  useEffect(() => {
    const token = localStorage.getItem("token");
    router.replace("/dashboard"); // guest mode: always show dashboard
  }, [router]);
  return null;
}
